<template>
  <ExcursionFilterPopupWrapper
    :title="title"
    :static-title="headerTitle"
    :is-modal-only="isFullscreen"
    modal-class="filter-price-modal"
    :is-active="isActive"
    filter-key="price"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="isScroll"
    @apply="handleApply"
  >
    <ExcursionFilterPriceContent v-bind="props" />
  </ExcursionFilterPopupWrapper>
</template>

<script setup lang="ts">
  import { ExcursionFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  import ExcursionFilterPriceContent from './ExcursionFilterPriceContent.vue';
  import { useExcursionFilterPriceTitle } from '@/features/filter/price/composables/excursion/useExcursionFilterPriceTitle.ts';
  import { useExcursionFiltersStore, type TExcursionFiltersState } from '@/entities/filter/store/excursion';
  import { locales } from '../../i18n';
  import type { CurrencyCode } from '@/shared/lib/currency';

  interface Props {
    histogram: Record<string, number>;
    minPrice: number;
    maxPrice: number;
    isFullscreen: boolean;
    isScroll: boolean;
    currencyCode: CurrencyCode | string;
    currencySymbol?: string;
  }

  interface Emits {
    (e: 'apply', isForced: boolean, filterData?: Partial<TExcursionFiltersState>): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const { title, headerTitle, isActive } = useExcursionFilterPriceTitle({
    messages: locales.ru,
    currencyCode: () => props.currencyCode,
    currencySymbol: () => props.currencySymbol,
  });

  const filterStore = useExcursionFiltersStore();

  const isDisabledResetButton = computed(() => {
    return !filterStore.state.price[0] && !filterStore.state.price[1];
  });

  const handleApply = (isForced: boolean) => {
    const filterData: Partial<TExcursionFiltersState> = {
      price: filterStore.searchState.price,
    };
    emit('apply', isForced, filterData);
  };
</script>

<style lang="scss" scoped>
  :deep(.filter-popup) {
    width: 368px;
    max-width: 100vw;

    .popup__content {
      padding-top: 5px;
    }
  }
</style>

<style lang="scss">
  .ui-modal.filter-price-modal {
    .ui-modal-footer {
      padding-right: 24px;
      padding-left: 24px;
    }
  }
</style>
